module.exports = __webpack_public_path__ + "img/switch-vertical-02.ea4401e8.svg";